<template>
  <div>
    <header-title :Title="'资源图谱'"></header-title>
    <div class="tui-Map">
      <div class="tui-MapBox">
        <div style="padding-top: 2.4625rem">
          <div class="tui-MapContent">
            <!-- 文化场馆 -->
            <div
              class="tui-MapItem"
              style="top: -26%"
              @click="onClickDetail(1)"
            >
              <img
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804105657_1860.png"
                alt=""
              />
            </div>
            <!-- 园所教育 -->
            <div
              class="tui-MapItem"
              style="left: 26%; top: -34%"
              @click="onClickDetail(2)"
            >
              <img
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804111023_1300.png"
                alt=""
              />
            </div>
            <!-- 休闲娱乐 -->
            <div
              class="tui-MapItem"
              style="left: 55%; top: -31%"
              @click="onClickDetail(3)"
            >
              <img
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804111559_1880.png"
                alt=""
              />
            </div>
            <!-- 公益环保 -->
            <div
              class="tui-MapItem"
              style="left: 77%; top: -24%"
              @click="onClickDetail(4)"
            >
              <img
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804111719_9771.png"
                alt=""
              />
            </div>
            <!-- 职业小达人 -->
            <div
              class="tui-MapItem"
              style="left: 0; top: 23%"
              @click="onClickDetail(8)"
            >
              <img
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-25/20220825151725_7704.png"
                alt=""
              />
            </div>
            <!-- 实践指导站 -->
            <div
              class="tui-MapItem"
              style="left: 24%; top: 15%"
              @click="onClickDetail(7)"
            >
              <img
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804112126_5077.png"
                alt=""
              />
            </div>
            <!-- 职业体验 -->
            <div
              class="tui-MapItem"
              style="left: 45%; top: 15%"
              @click="onClickDetail(6)"
            >
              <img
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804112259_0017.png"
                alt=""
              />
            </div>
            <!-- 法制天地 -->
            <div
              class="tui-MapItem"
              style="left: 68%; top: 22%"
              @click="onClickDetail(5)"
            >
              <img
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804112413_7534.png"
                alt=""
              />
            </div>
            <!-- 健康生存 -->
            <div
              class="tui-MapItem"
              style="left: 6%; top: 60%"
              @click="onClickDetail(9)"
            >
              <img
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804134742_4283.png"
                alt=""
              />
            </div>
            <!-- 科普教育 -->
            <div
              class="tui-MapItem"
              style="left: 28%; top: 59%"
              @click="onClickDetail(10)"
            >
              <img
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804134945_3319.png"
                alt=""
              />
            </div>
            <!-- 民族文化 -->
            <div
              class="tui-MapItem"
              style="left: 53%; top: 61%"
              @click="onClickDetail(11)"
            >
              <img
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804135059_9718.png"
                alt=""
              />
            </div>
            <!-- 艺术人文 -->
            <div
              class="tui-MapItem"
              style="left: 80%; top: 60%"
              @click="onClickDetail(12)"
            >
              <img
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804135229_6783.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 富文本测试 -->
    <!-- <div class="tui-quillContent">
      <quill-editor
        v-model="addForm.useExplain"
        :options="editorOption"
        ref="myQuillEditor"
        @blur="onEditorBlur($event)"
        @focus="onEditorFocus($event)"
        @change="onEditorChange($event)"
        style="height: 100%"
      ></quill-editor>
      <div style="text-align: right">{{ TiLength }}/2000</div>
    </div>
    <el-button type="primary">主要按钮</el-button> -->
  </div>
</template>
<script>
import headerTitle from "@/components/headerTitle/headerTitle.vue";

export default {
  components: {
    headerTitle,
  },
  data() {
    return {
      // 限制长度
      TiLength: 0,
      addForm: {
        useExplain: 0,
      },
      editorOption: {
        theme: "snow",
        modules: {
          toolbar: [
            //下面是控制工具栏的展示功能 见 https://blog.csdn.net/qq_36947168/article/details/119486710
            // https://www.kancloud.cn/liuwave/quill/1409378
            ["bold", "italic", "underline"],
            // ['blockquote', 'code-block'],
            // [{ 'header': 1 }, { 'header': 2 }],
            // [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            // [{ 'script': 'sub'}, { 'script': 'super' }],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ direction: "rtl" }],
            // [{ 'size': ['small', false, 'large', 'huge'] }],
            // [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            // [{ 'color': [] }, { 'background': [] }],
            // [{ 'font': [] }],
            // [{ 'align': [] }],
            // ['clean'],
            // ['image','video']
          ],
        },
      },
    };
  },
  mounted() {
    //数据初始化
    this.TiLength = this.$refs.myQuillEditor.quill.getLength() - 1;
  },
  methods: {
    onEditorChange(event) {
      event.quill.deleteText(2000, 1);
      if (this.addForm.useExplain === 0) {
        this.TiLength = 0;
      } else {
        this.TiLength = event.quill.getLength() - 1;
      }
    },
    onClickDetail(index) {
      this.$router.push({
        path: "/tool-Map/index",
        query: {
          t: +new Date(), //保证每次点击路由的query项都是不一样的，确保会重新刷新view
          Index: index,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.tui-quillContent {
  width: 90%;
  height: 500px;
  background: #fff;
  margin: 0 auto;
}
.tui-Map {
  height: 10.925rem;
  overflow-y: hidden;
  .tui-MapBox {
    height: 100%;
    background: url("http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804094306_7483.png")
      no-repeat;
    background-size: 100% 100%;

    .tui-MapContent {
      width: 14.6875rem;
      height: 7rem;
      // background: red;
      margin: 0 auto;
      background: url("http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-8/2022-8-4/20220804105346_9178.png")
        no-repeat;
      background-size: 100% 100%;
      position: relative;
      .tui-MapItem {
        position: absolute;
        top: 0;
        left: 0;
        width: 3.6rem;
        height: 3.6rem;
        transition: all 0.5s;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
        img:hover {
          transform: scale(1.1);
        }
      }
    }
  }
}
</style>